export const API_CONFIG = {
  baseURL: {
    development: "https://molly-api-dev.fridayuniversal.co.th",
    production: import.meta.env.VITE_API_URL, // Will be updated with PROD URL
  },
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
} as const;

export const getBaseUrl = (): string => {
  const env = import.meta.env.MODE;
  return API_CONFIG.baseURL[env as keyof typeof API_CONFIG.baseURL];
};

export const getApiHeaders = (additionalHeaders: Record<string, string> = {}) => {
  return {
    ...API_CONFIG.headers,
    ...additionalHeaders,
  };
};
